import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';
import { Subject } from 'rxjs';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { UserDatePipe } from '../../../../../shared/pipes/user-date.pipe';

@Component({
  selector: 'app-print-case-behavior',
  standalone: true,
  imports: [CommonModule, UserDatePipe],
  templateUrl: './print-case-behavior.component.html',
})
export class PrintCaseBehaviorComponent implements OnDestroy {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  printData: any = null;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Input() set behaviorData(val: any) {
    this.initializeBehaviorData(val);
  }

  private async initializeBehaviorData(val: any) {
    this.printData = val;
    this.cd.detectChanges();
    this.initialized = true;
  }
  @ViewChild('pdfContent', { static: true }) pdfContent!: ElementRef;
  initialized = false;
  private readonly destroy$ = new Subject<void>();
  private readonly LONG_WORD_LENGTH = 20;
  private readonly ZERO_WIDTH_SPACE = '​';

  constructor(private readonly cd: ChangeDetectorRef) {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    (pdfMake.vfs as any) = pdfFonts;
  }

  // pdfMake only wraps at break opportunities (spaces etc.) and has no
  // word-break option, so an unbroken run like "sssss…" or
  // "AutoQuestion20260422114195" overflows the page/column. Interleaving
  // zero-width spaces (Roboto renders them with 0 advance) into long runs lets
  // pdfMake wrap them like any other text.
  breakLongWords(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).replace(
      new RegExp(`\\S{${this.LONG_WORD_LENGTH},}`, 'g'),
      word => word.split('').join(this.ZERO_WIDTH_SPACE)
    );
  }

  getFrequencyAnswer() {
    let string = '';
    if (this.printData.form.behaviourFrequencyId) {
      string = `It usually occurs at least once and possibly several times ${this.printData.form.behaviourFrequencyId}.`;
    }
    if (this.printData.form.behaviourFrequencyCount) {
      string = `${string} On average ${this.printData.form.behaviourFrequencyCount} time(s)`;
    }
    string =
      !!this.printData.form.behaviourFrequencyCount &&
      !!this.printData.form.duration
        ? `${string} for ${this.printData.form.duration} minute(s).`
        : `${string}.`;

    return string;
  }

  async printPDF() {
    if (this.printData) {
      const pdfContent = document.getElementById('pdf-data');
      if (pdfContent) {
        // Convert HTML to pdfMake format
        const pdfMakeContent = htmlToPdfmake(pdfContent.innerHTML);

        // Define the PDF document
        const documentDefinition: TDocumentDefinitions = {
          content: pdfMakeContent,
          pageMargins: [20, 20, 20, 20],
          footer: function (currentPage: number) {
            return {
              columns: [
                {
                  text: ``,
                  alignment: 'left',
                },
                {
                  text: `Powered by Insights to Behavior®`,
                  alignment: 'center',
                },
                {
                  text: `${currentPage}`,
                  alignment: 'right',
                },
              ],
              margin: [15, 0, 10, 0],
              color: '#475467',
            };
          },
          // header: function (currentPage: any, pageCount: any, pageSize: any) {
          //   return [
          //     {
          //       text: 'simple text',
          //       tocItem: true,
          //     },
          //   ];
          // },
          styles: {
            desc: {
              fontSize: 12,
            },
            address: {
              fontSize: 12,
            },
            title: {
              fontSize: 12,
            },
            datalabel: {
              lineHeight: 1.5,
              color: '#475467',
            },
            dataValue: {
              color: '#475467',
            },
            columns: {
              columnGap: 10,
            },
          },
          defaultStyle: {
            columnGap: 10,
            fontSize: 12,
          },
        };

        // Generate and download the PDF
        pdfMake
          .createPdf(documentDefinition)
          .download(
            `${this.printData?.caseParams.case.student.firstName} ${this.printData?.caseParams.case.student.lastName}_Behavior.pdf`
          );
        this.initialized = false;
        this.ngOnDestroy();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
